module.exports = __webpack_public_path__ + "images/FF_Stylist_logof81710948748f8e1bbfd3b3c141ca3f7.png";